import merge from '~lodash.mergewith'
import * as CoreSdk from '~@sentry/core'
import { captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } from '~@sentry/browser'
import { replayIntegration } from '~@sentry/browser'
import { extraErrorDataIntegration, reportingObserverIntegration } from '~@sentry/integrations'
import { init } from '~@sentry/vue'

export { init }
export const SentrySdk = { ...CoreSdk, ...{ captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } }

/** @type {string[]} */
const DISABLED_INTEGRATION_KEYS = []

/**
 * @typedef {Parameters<typeof init>[0]} InitConfig
 * @param {import('@nuxt/types').Context} ctx
 * @return {Promise<InitConfig>}
 */
export function getConfig (ctx) {
  /** @type {InitConfig} */
  const config = {
    dsn:"https:\u002F\u002Ffab67430a56d9582342620c55432e455@o4507827217760256.ingest.de.sentry.io\u002F4507905846411344",
    environment:"production",
    debug:true,
    release:"1a62da30b22ffd77e1c3e01f50c799a1d45c9acf",
    tracesSampleRate:0.1,
    tracePropagationTargets:["localhost",undefined,"https:\u002F\u002Fadmin.ecom.md"],
    profilesSampleRate:1,
    attachStacktrace:true,
    beforeSend:function(event) {
          if (event?.exception && event?.exception.values) {
            const ignoredMessages = [
            'Request canceled due to unauthorized state',
            'Cannot set headers after they are sent to the client',
            "Can't find variable: gmo"];

            const isIgnoredError = event.exception.values.some(
              (exception) => exception.value && ignoredMessages.some((msg) => exception.value.includes(msg))
            );

            if (isIgnoredError) {
              return null;
            }
          }

          return event;
        },
    replaysSessionSampleRate:0.7,
    replaysOnErrorSampleRate:1,
  }

  /** @type {NonNullable<InitConfig>['integrations']} */
  const resolvedIntegrations = [
    extraErrorDataIntegration(),
    reportingObserverIntegration({ types:["crash"] }),
    replayIntegration({ maskAllText:false,maskAllInputs:false,blockAllMedia:false,networkCaptureBodies:true,networkDetailAllowUrls:["https:\u002F\u002Fsportline.md"],networkRequestHeaders:["Authorization","Content-Type"],networkResponseHeaders:["Content-Type","Set-Cookie"] }),
  ]

  config.integrations = (defaultIntegrations) => {
    return [
      ...defaultIntegrations.filter(integration => !DISABLED_INTEGRATION_KEYS.includes(integration.name)),
      ...resolvedIntegrations,
    ]
  }
  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  return config
}
